<div class="flex flex-row mr-8">
  <p-dropdown [options]="warehouses" optionLabel="name"
  placeholder="Select warehouse" [(ngModel)]="selectedWarehouse">
</p-dropdown>

</div>
